import React from 'react';

const Item = ({ reference, index, referenceSidebarRefs }) => {
  function jumpToContentRef() {
    document.getElementById(`ref-${index + 1}`).scrollIntoView();
  }

  return (
    <div
      className="single-article__references-item reference"
      key={index}
      ref={(ref) => (referenceSidebarRefs.current[index] = ref)}
      style={{
        gridRow: `${index * 2 + 2}/${index * 2 + 3}`,
      }}
      id={`reference-item-${index + 1}`}
    >
      <button className="reference__index reference__index--link" onClick={jumpToContentRef}>
        {index + 1}
      </button>
      <div className="reference__index reference__index--text">{index + 1}</div>
      <div className="reference__text" dangerouslySetInnerHTML={{ __html: reference?.text }} />
    </div>
  );
};

export default Item;
